import { render, staticRenderFns } from "./SliderInfinite.vue?vue&type=template&id=5353c8fe&"
import script from "./SliderInfinite.vue?vue&type=script&lang=js&"
export * from "./SliderInfinite.vue?vue&type=script&lang=js&"
import style0 from "./SliderInfinite.vue?vue&type=style&index=0&id=5353c8fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports